import type { Alert } from '@/types';

export type AlertSeverity = Alert['severity'];

/**
 * Converts persisted or realtime alert severity values to the lowercase
 * application contract while retaining deliberate legacy aliases.
 */
export function normalizeAlertSeverity(value: unknown): AlertSeverity | null {
  const normalized = String(value ?? '').trim().toLowerCase();
  if (
    normalized === 'low'
    || normalized === 'medium'
    || normalized === 'high'
    || normalized === 'critical'
  ) {
    return normalized;
  }
  if (normalized === 'advisory') return 'low';
  if (normalized === 'warning') return 'medium';
  return null;
}

export function isElevatedAlertSeverity(value: unknown): boolean {
  const severity = normalizeAlertSeverity(value);
  return severity === 'high' || severity === 'critical';
}
